import { CasesQuickFilter } from "@/Pages/Cases/CasesQuickFilter";
import type { ComparisonFilter, Filter, FilterSet, InFilter } from "@/Pages/Cases/filtering/filters/CaseFilter";
import { complaintToQuickFilterMap } from "@/Pages/Cases/functions/filter_functions";
import { getKeyByValue } from "@/Pages/Cases/functions/getKeyByValue";
import { CaseFilterGroup } from "@/Pages/Cases/filtering/CaseFilterGroup";
import { Operator } from "@/Pages/Cases/store/filterCases";
import { CadNames } from "@/App/components/Cad/types/CadNames";

export const quickFilterToFilter = (quickFilter: CasesQuickFilter): Filter => {
  let filterToReturn: Filter;
  switch (quickFilter) {
    case CasesQuickFilter.Critical:
    case CasesQuickFilter.Routine:
    case CasesQuickFilter.Unknown:
    case CasesQuickFilter.Urgent:
      const priority = getKeyByValue(complaintToQuickFilterMap, quickFilter);
      if (priority) {
        filterToReturn = { fieldName: "complaint.priority", value: priority } as ComparisonFilter;
        break;
      } else {
        throw new Error("unrecognized case priority");
      }
    case CasesQuickFilter.Consult:
      filterToReturn = { fieldName: "isVideoConsultInProgress", value: true } as ComparisonFilter;
      break;
    case CasesQuickFilter.Unacknowledged:
      filterToReturn = { fieldName: "isAcknowledged", values: [false, undefined] } as InFilter;
      break;
    case CasesQuickFilter.IftOpen:
      filterToReturn = {
        filters: [
          { fieldName: "ift.closed", value: undefined },
          { fieldName: "ift.canceled", value: undefined },
          { fieldName: "cadStatus", negative: true, value: CadNames.inService },
        ] as ComparisonFilter[],
      } as FilterSet;
      break;
    case CasesQuickFilter.Closed:
      filterToReturn = {
        filters: [
          { fieldName: "ift.closed", value: undefined, negative: true },
          { fieldName: "cadStatus", value: CadNames.inService },
        ] as ComparisonFilter[],
        operator: Operator.OR,
      } as FilterSet;
      break;
    case CasesQuickFilter.Canceled:
      filterToReturn = { fieldName: "ift.canceled", value: undefined, negative: true } as ComparisonFilter;
      break;
    case CasesQuickFilter.Unassigned:
      filterToReturn = {
        filters: [
          { fieldName: "ift.assigned.candidateEmsUsers.length", value: 0 },
          { fieldName: "ift.closed", value: undefined, negative: false },
          { fieldName: "ift.canceled", value: undefined, negative: false },
        ] as ComparisonFilter[],
      } as FilterSet;
      break;
    case CasesQuickFilter.EnRoute:
      filterToReturn = { fieldName: "cadStatus", value: CadNames.enRoute } as ComparisonFilter;
      break;
    case CasesQuickFilter.OnScene:
      filterToReturn = { fieldName: "cadStatus", value: CadNames.onScene } as ComparisonFilter;
      break;
    case CasesQuickFilter.Labs:
      filterToReturn = { fieldName: "cadStatus", value: CadNames.labs } as ComparisonFilter;
      break;
    case CasesQuickFilter.JobFinished:
      filterToReturn = { fieldName: "cadStatus", value: CadNames.jobFinished } as ComparisonFilter;
      break;
  }
  filterToReturn.group = CaseFilterGroup.quickFilter;
  return filterToReturn;
};
